

import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';

import { MwcSafeAny } from 'mwc/core/types';

import { MwcCheckboxComponent } from './checkbox.component';

@Component({
  selector: 'mwc-checkbox-wrapper',
  exportAs: 'mwcCheckboxWrapper',
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: ` <ng-content></ng-content> `,
  host: {
    class: 'mwc-checkbox-group'
  }
})
export class MwcCheckboxWrapperComponent {
  @Output() readonly mwcOnChange = new EventEmitter<MwcSafeAny[]>();
  private checkboxList: MwcCheckboxComponent[] = [];

  addCheckbox(value: MwcCheckboxComponent): void {
    this.checkboxList.push(value);
  }

  removeCheckbox(value: MwcCheckboxComponent): void {
    this.checkboxList.splice(this.checkboxList.indexOf(value), 1);
  }

  onChange(): void {
    const listOfCheckedValue = this.checkboxList.filter(item => item.mwcChecked).map(item => item.mwcValue);
    this.mwcOnChange.emit(listOfCheckedValue);
  }
}
